export default __webpack_public_path__ + "img/community-pic.c9ac0cb1.png";